import React, { useCallback, useState, useContext, useEffect } from 'react';
import { DataGrid, GridColumns } from '@material-ui/data-grid';

import { Row, Col } from 'react-bootstrap';
import Separator from '~/components/Separator';
import {
  InputSelect,
  InputAsyncSelect,
  InputNumberDias,
} from '~/components/NovosInputs';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { CancelButton, ConfirmButton } from '~/components/Buttons';
import { LojaContext } from '~/context/loja';
import { useClienteContext } from '../../ClienteContext';
import { Options } from '../../types';
import { GoPencil } from 'react-icons/go';
import { MdDeleteForever } from 'react-icons/md';
import { ButtonRow } from '../../styles';
import { deleteItens } from '~/utils/masterDetail';

export const AbaCondicao: React.FC = () => {
  const [page, setPage] = useState<number>(0);

  const {
    diasCondicao,
    setDiasCondicao,
    condicoes,
    initFinalizadora,
    setInitFinalizadora,
    condicoesOptions,
    condicaoAEditar,
    condicaoRegister,
    condicaoControl,
    setValueCondicao,
    formStateCondicao,
    SaveCondicao,
    handleClearCondicao,
    setCondicaoAEditar,
    masterDetail,
    setMasterDetail,
    setCondicoes,
    resetFieldsCondicao,
    setResetFieldsCondicao,
  } = useClienteContext();
  const { codLoja } = useContext(LojaContext);

  const colunasCondicao: GridColumns = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      sortable: false,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'des_finalizadora',
      headerName: 'Finalizadora',
      type: 'string',
      flex: 2,
      sortable: false,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'num_condicao',
      headerName: 'Condição',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      type: 'number',
      sortable: true,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'des_condicao',
      headerName: 'Tipo da Condição',
      flex: 2,
      sortable: false,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: '',
      headerName: 'Ações',
      width: 180,
      sortable: false,
      headerClassName: 'super-app-theme--header',
      renderCell: (params: { row: any }) => {
        const onEdit = () => {
          const { row } = params;

          setValueCondicao('condicaoFinalizadora', {
            value: row.cod_finalizadora,
            label: row.des_finalizadora,
          });

          setValueCondicao('condicao', {
            value: row.cod_condicao,
            label: row.des_condicao,
          });

          setValueCondicao('numCondicao', row.num_condicao);
          setDiasCondicao(row.num_condicao);
          setCondicaoAEditar({
            uuid: row.uuid,
            cod_seq_pessoa_condicao: row.cod_seq_pessoa_condicao,
          });
          const elm = document.getElementById('collapseThree-cliente');
          if (elm) {
            elm.removeAttribute('class');
            elm.classList.add('accordion-collapse', 'collapse', 'show');
          }
        };
        const onDelete = () => {
          const { row } = params;
          handleRemoveCondicao(row.uuid);
        };

        return (
          <>
            <ButtonRow type="button" onClick={onEdit}>
              <GoPencil size={20} style={{ color: '#72ab90' }} /> Editar
            </ButtonRow>
            <ButtonRow type="button" onClick={onDelete}>
              <MdDeleteForever size={20} style={{ color: '#e63c3c' }} /> Excluir
            </ButtonRow>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (resetFieldsCondicao) {
      const input = document.getElementById('tipoCondicao') as HTMLInputElement;
      if (input) {
        input.value = 'DIAS DA DATA - DD';
      }
      setResetFieldsCondicao(false);
    }
  }, [resetFieldsCondicao]);

  const handleRemoveCondicao = useCallback(
    async (uuid) => {
      const autorizadosDetail: any[] = await deleteItens(
        'condicao',
        uuid,
        masterDetail,
        setMasterDetail,
      );
      setCondicoes(autorizadosDetail);
      handleClearCondicao();
    },
    [handleClearCondicao, masterDetail],
  );

  return (
    <div className="row" style={{ marginBottom: '60px' }}>
      <Col sm={12}>
        <Separator labelText="Condição de Pagamento" childrenWidth="170px">
          <button
            type="button"
            className="btnLimiteCredito"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree-cliente"
            aria-expanded="false"
            aria-controls="collapseThree"
            style={{
              marginTop: '-7px',
              backgroundColor: '#F4F5F7',
            }}
          >
            <AiOutlinePlusCircle
              size={16}
              style={{ marginTop: '-2px', color: 'green' }}
            />{' '}
            Adicionar Condição
          </button>
        </Separator>
      </Col>
      {/* Inicio accordion */}
      <div
        className="accordion"
        id="accordionCondicao"
        style={{ marginBottom: '15px', padding: '0px' }}
      >
        <div
          id="collapseThree-cliente"
          className="accordion-collapse collapse"
          aria-labelledby="headingOne"
          data-bs-parent="#accordionCondicao"
        >
          <div className="accordion-body">
            <Row>
              <Col sm={12} md={3} className="finalizadoraContainer">
                <div>
                  <InputAsyncSelect
                    label="Finalizadora"
                    placeholder="Selecione"
                    name="condicaoFinalizadora"
                    maxLength={50}
                    register={condicaoRegister}
                    isError={
                      initFinalizadora &&
                      !!formStateCondicao.errors.condicaoFinalizadora
                    }
                    control={condicaoControl}
                    changeSelected={(selected) => {
                      setInitFinalizadora(false);
                      setValueCondicao('condicaoFinalizadora', selected);
                    }}
                    api={{
                      route: '/finalizadora/ativas',
                      method: 'get',
                      bodyParams: {
                        codLoja,
                      },
                      fields: ['cod_finalizadora', 'des_finalizadora'],
                      dependsOf: ['codLoja'],
                      messageForDependsOf:
                        'É necessário selecionar a loja na capa da NF',
                      searchBeforeFilter: true,
                    }}
                  />
                </div>
              </Col>
              <Col
                className="inputDiasContainer"
                sm={12}
                md={1}
                style={{ minWidth: '160px', marginTop: '5px' }}
              >
                <InputNumberDias
                  label="Condição"
                  min={0}
                  value={diasCondicao}
                  placeholder=""
                  isDisabled={false}
                  onChange={(val: any) => {
                    setValueCondicao('numCondicao', val);
                    setDiasCondicao(val);
                  }}
                  inputWidth="100%"
                />
              </Col>
              <Col sm={12} md={4} className="tipoCondicao">
                <div style={{ marginLeft: '-8px' }}>
                  <InputSelect
                    id="tipoCondicao"
                    label="Tipo da Condição"
                    name="condicao"
                    register={condicaoRegister}
                    isError={!!formStateCondicao.errors.condicao}
                    control={condicaoControl}
                    options={condicoesOptions}
                    changeSelected={(selected: Options) => {
                      setValueCondicao('condicao', selected);
                    }}
                  />
                </div>
              </Col>
              <Col
                sm={12}
                md={4}
                className="buttonContainer"
                style={{ paddingRight: '0px' }}
              >
                <div className="actButtonsCredito">
                  <ConfirmButton
                    style={{ height: '42px' }}
                    onClick={() => {
                      SaveCondicao();
                    }}
                  >
                    {condicaoAEditar ? 'Editar' : 'Confirmar'}
                  </ConfirmButton>
                  <CancelButton
                    style={{ height: '42px' }}
                    onClick={handleClearCondicao}
                  >
                    Cancelar
                  </CancelButton>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* fim accordion */}
      <Col sm={12} className="dataTable" style={{ height: 280, width: '100%' }}>
        <Col
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            marginBottom: '50px',
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              className="myDataGrid"
              rows={condicoes}
              columns={colunasCondicao}
              autoHeight
              sortModel={[
                {
                  field: 'num_condicao',
                  sort: 'asc',
                },
              ]}
              columnBuffer={8}
              disableColumnFilter
              disableColumnSelector
              disableSelectionOnClick
              disableColumnMenu
              pageSize={4}
              onPageChange={(newPage) => setPage(newPage)}
              page={page}
              localeText={{
                noRowsLabel: 'Nenhum registro encontrado',
                columnMenuLabel: 'Menu',
                columnMenuFilter: 'Filtrar',
                columnMenuHideColumn: 'Esconder',
                columnMenuUnsort: 'Não ordenar',
                columnMenuSortAsc: 'Ordernar ASC',
                columnMenuSortDesc: 'Ordernar DESC',
                columnMenuShowColumns: 'Mostrar colunas',
              }}
            />
          </div>
        </Col>
      </Col>
    </div>
  );
};
